import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
// import { setCurrentUser } from "../store/actions/authActions.js";
import { Button, Modal } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import TableSearchBar from "../../components/TableSearchBar";
import instance, {
  fetchAllDepartments,
  fetchAssessmentDueDate,
} from "../../api/api";
import { initFlowbite } from "flowbite";
import {
  getLikelihoodName,
  getLikelihoodValues,
} from "../../constants/likelihoodValues";
import { getConsequenceValues, getConsequenceName } from "../../constants/consequenceValues";
import { Loader } from "../../components/Loader";
import PerspectiveBadge from "../../components/PerspectiveBadge";
import { getControlEffectivenessValues, getControlEffectivenessName } from "../../constants/controlEffectivenessValues";
import "../../styles/styles.css";
import { usePostHog } from "@posthog/react";
import { useTenant } from "../../context/Tenant/TenantContext";
import { getRiskScoreColorClass } from "../../utils/riskLevel";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
  getSortedRowModel,
  SortingState,
} from "@tanstack/react-table";
// import GetScoreColor from "../../utils/GetScoreColor";

type Risk = {
  id: string;
  riskRegisterId: string;
  riskName: string;
  riskNumber: string;
  perspective: string;
  objective: string;
  source: string;
  description: string;
  rootCause: string;
  likeLihoodValue: number;
  likeLihoodValueScore: number;
  riskConsequenceValue: number;
  riskConsequenceValueScoreAverage: number;
  controlEffectivenessScore: number;
  inherentRiskScore: number;
  residualRiskScore: number;
  likeLihoodComment: string;
  riskConsequenceValueScore: number;
  riskConsequenceComment: string;
  controlEffectiveness: string;
  likeLihoodValueScoreAverage: number;
  controlEffectivenessScoreAverage: number;
  responseText?: string;
};

function AdminRiskAssessmentFinalization() {
  const posthog = usePostHog();
  const { config } = useTenant();
  const [moreDetailsRequested, setMoreDetailsRequested] = useState(false);

  const [currentRiskDetails, setCurrentRiskDetails] = useState<any>([]);
  const [isLoadingRisks, setIsLoadingRisks] = useState(false);
  const [allRisks, setAllRisks] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  // const [selectedRiskId, setSelectedRiskId] = useState<string>("");
  const [openModal, setOpenModal] = useState(false);

  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);
  const [drawerKey, setDrawerKey] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [searchTerm, setSearchTerm] = useState("");
  const [sorting, setSorting] = useState<SortingState>([
    { id: "riskNumber", desc: false },
  ]);
  // const [dueDate, setDueDate] = useState<any>(null);
  const [isAssessmentLocked, setIsAssessmentLocked] = useState(false);
  const today = new Date();

  const [departments, setDepartments] = useState<any[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [highlightedRiskId, setHighlightedRiskId] = useState<any>(null);
  const editDrawerRef = useRef<any>(null);
  const closeEditRiskDrawerButtonRef = useRef<any>(null);

  useEffect(() => {
    const fetchDepartments = async () => {
      setDepartments(await fetchAllDepartments());
    };
    fetchDepartments();
  }, []);

  useEffect(() => {
    posthog?.capture("page_viewed", { page: "admin_risk_assessment" });
  }, [posthog]);

  const getAllRisks = async () => {
      try {
        setIsLoadingRisks(true);

        let assessmentResponse;

        const riskRegistryResponse = await instance.get(
          "/api/admin/riskRegister/riskRegisters/selections/SELECTION_COMPLETE"
        );

        if (selectedDepartment === "" || selectedDepartment === "All") {
          assessmentResponse = await instance.get(
            "/api/admin/riskAssessment/riskAssessments/scores/average"
          );
        } else {
          assessmentResponse = await instance.get(
            `/api/admin/riskAssessment/riskAssessments?departmentName=${selectedDepartment}`
          );
        }

        let riskResponses: any;
        try {
          const riskResponse = await instance.get(
            "/api/admin/riskResponse/riskResponses/all"
          );
          riskResponses =
            riskResponse && riskResponse.data ? riskResponse.data.data : [];
        } catch (error: any) {
          if (error.response && error.response.status === 404) {
            console.warn("Risk responses not found, continuing without them.");
          } else {
            throw error;
          }
        }

        // const riskResponse = await instance.get(
        //   "/api/admin/riskResponse/riskResponses/all"
        // );

        const riskAssessmentAveragesResponse = await instance.get(
          "/api/admin/riskAssessment/riskAssessments/all/APPROVED_FOR_ACTION"
        );

        const riskRegister = riskRegistryResponse.data.data;
        const riskAssessments = assessmentResponse.data.data;
        const riskAssessmentAverages =
          riskAssessmentAveragesResponse && riskAssessmentAveragesResponse.data
            ? riskAssessmentAveragesResponse.data.averages
            : [];

        setIsLoadingRisks(false);
        initFlowbite();

        const combinedRisks = riskAssessments
          .filter((assessment: any) =>
            riskRegister.some(
              (register: any) => register.id === assessment.riskRegisterId
            )
          )
          .map((assessment: any) => {
            const registers = riskRegister.find(
              (register: any) => register.id === assessment.riskRegisterId
            );

            console.log("this is the assessment: ", assessment) //riskRegisterId

            return {
              ...assessment,
              assessmentId: assessment.id,
              riskName: registers.riskName,
              riskNumber: registers.riskNumber,
              perspective: registers.perspective,
              objective: registers.objective,
              source: registers.source,
              description: registers.description,
              rootCause: registers.rootCause,
            };
          });

        // Filter out risks that are present in riskResponse
        const filteredRisks = combinedRisks.filter((risk: any) =>
          riskResponses
            ? !riskResponses.some(
                (response: any) => response.riskRegisterId === risk.riskRegisterId
              )
            : combinedRisks
        );

        setAllRisks(combinedRisks);
        const risksWithAverages = filteredRisks.map((risk: any) => {
          const averages = riskAssessmentAverages.find(
            (average: any) => average.id === risk.assessmentId
          );
          return {
            ...risk,
            likeLihoodValueScoreAverage: averages
              ? averages._avg.likeLihoodValueScore
              : 0,
            riskConsequenceValueScoreAverage: averages
              ? averages._avg.riskConsequenceValueScore
              : 0,
          };
        });

        risksWithAverages.sort(
          (a: any, b: any) => b.residualRiskScore - a.residualRiskScore
        );
        setAllRisks(risksWithAverages);
      } catch (error) {
        setIsLoadingRisks(false);
        console.error(error);
      }
    };

  useEffect(() => {
    const fetchDueDate = async () => {
      const theDueDate = await fetchAssessmentDueDate();
      // setDueDate(FormatDueDates(theDueDate));
      if (theDueDate && theDueDate < today) {
        setIsAssessmentLocked(false);
      } else {
        setIsAssessmentLocked(false);
      }
    };

    fetchDueDate();

    

    getAllRisks();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepartment]);

  
  const handleOpenEditDrawer = (riskId: string) => {
    const risk = allRisks.find((risk: Risk) => risk.id === riskId);
    setIsEditDrawerOpen(true);
    setCurrentRiskDetails(risk);
    setDrawerKey((k) => k + 1);
    setHighlightedRiskId(riskId);
  };

  const handleCreateRiskAssessment = async (e: any) => {
    e.preventDefault();

    const likelihood = Number(currentRiskDetails?.likeLihoodValue);
    const consequence = Number(currentRiskDetails?.riskConsequenceValue);
    const control = Number(currentRiskDetails?.controlEffectivenessScore);

    if (!likelihood || !consequence || !control) {
      alert(
        "Please provide all three scores — Likelihood, Impact, and Control Strength — before saving."
      );
      return;
    }

    setIsSubmitting(true);
    try {
      // Save the assessment scores
      await instance.post(
        `/api/employee/riskAssessment/create/${currentRiskDetails.riskRegisterId}`,
        {
          likeLihoodValue: currentRiskDetails.likeLihoodValue,
          likeLihoodValueScore: Number(currentRiskDetails.likeLihoodValue),
          likeLihoodComment: currentRiskDetails.likeLihoodComment
            ? currentRiskDetails.likeLihoodComment
            : "",
          riskConsequenceValue: currentRiskDetails.riskConsequenceValue,
          riskConsequenceValueScore: Number(
            currentRiskDetails.riskConsequenceValue
          ),
          riskConsequenceComment: currentRiskDetails.riskConsequenceComment
            ? currentRiskDetails.riskConsequenceComment
            : "",
          controlEffectiveness: currentRiskDetails.controlEffectiveness
            ? currentRiskDetails.controlEffectiveness
            : "",
          controlEffectivenessScore: Number(
            currentRiskDetails.controlEffectivenessScore
          ),
          responseText: currentRiskDetails.responseText,
        }
      );

      // // Save the action plan if provided
      // if (currentRiskDetails.responseText && currentRiskDetails.responseText.trim() !== "") {
      //   await instance.post(
      //     `/api/employee/riskResponse/create/${currentRiskDetails.riskRegisterId}`,
      //     {
      //       responseText: currentRiskDetails.responseText,
      //     }
      //   );
      // }

      if (closeEditRiskDrawerButtonRef.current) {
        closeEditRiskDrawerButtonRef.current.click();
      }
      posthog?.capture("risk_assessment_submitted", {
        riskId: currentRiskDetails.riskRegisterId,
        likelihood: likelihood,
        consequence: consequence,
        control: control,
      });
      setIsSubmitting(false);
      await getAllRisks();
    } catch (error) {
      setIsSubmitting(false);
      return error;
    }
  };

  const deleteRisk = async (e: any) => {
    e.preventDefault();
    setIsDeleting(true);

    try {
      await instance.delete(
        `/api/employee/riskAssessment/delete/${currentRiskDetails.assessmentId}`
      );
      if (closeEditRiskDrawerButtonRef.current) {
        closeEditRiskDrawerButtonRef.current.click();
      }
      setIsDeleting(false);
      setOpenModal(false);
      await getAllRisks();
    } catch (error) {
      setIsDeleting(false);
      return error;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        editDrawerRef.current &&
        !editDrawerRef.current.contains(event.target)
      ) {
        setIsEditDrawerOpen(false);
        setHighlightedRiskId(null);
      }
    };

    if (isEditDrawerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      setHighlightedRiskId(null);
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditDrawerOpen]);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  // Calculate the items to display based on the current page and items per page
  const paginatedRisks = React.useMemo(() => {
    let risksToDisplay = allRisks;

    // Apply search filter
    if (searchTerm) {
      risksToDisplay = risksToDisplay.filter((risk: any) =>
        Object.values(risk).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return risksToDisplay.slice(indexOfFirstItem, indexOfLastItem);
  }, [allRisks, currentPage, itemsPerPage, searchTerm]);

  const totalPages = Math.ceil(allRisks.length / itemsPerPage);
  const handleMoreDetailsRequest = () => {
    setMoreDetailsRequested(!moreDetailsRequested);
  };

  const columnHelper = createColumnHelper<Risk>();
  const columns = [
    columnHelper.accessor("riskNumber", {
      header: () => <span className="whitespace-nowrap">Risk Number</span>,
      cell: (info) => <span className="whitespace-nowrap font-bold">{info.renderValue()}</span>,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("riskName", {
      header: () => <span className="whitespace-nowrap">Risk Name</span>,
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.perspective, {
      id: "perspective",
      cell: (info) => <PerspectiveBadge value={info.getValue()} />,
      header: () => <span>Perspective</span>,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("objective", {
      header: () => "Objective",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("likeLihoodValue", {
      header: () => "Likelihood Value",
      cell: (info) => (
        <div className="h-full whitespace-nowrap">
          {info.getValue()}{" "}
          {getLikelihoodName(info.row.original.likeLihoodValue, config) || (
            <span className="text-red italic">{"- Required -"}</span>
          )}
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("riskConsequenceValue", {
      header: () => "Risk Consequence Value",
      cell: (info) => (
        <div className="h-full whitespace-nowrap">
          {info.getValue()}{" "}
          {getConsequenceName(info.row.original.riskConsequenceValue, config) || (
            <span className="text-red italic">{"- Required -"}</span>
          )}
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("controlEffectivenessScore", {
      header: () => "Control Strength",
      cell: (info) => (
        <div className="whitespace-nowrap">
          {info.getValue()}{" "}
          {getControlEffectivenessName(info.row.original.controlEffectivenessScore, config) || (
            <span className="text-red italic">{"- Required -"}</span>
          )}
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("inherentRiskScore", {
      header: () => "Inherent Risk Score",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("residualRiskScore", {
      header: () => "Residual Risk Score",
      cell: (info) => (
        <div
          className={getRiskScoreColorClass(info.row.original.residualRiskScore, config?.RiskLevels)}
        >
          {info.getValue()}
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("likeLihoodComment", {
      header: () => "Likelihood Comment",
      cell: (info) => (
        <div className="">
          {info.getValue() || (
            <span className="text-red italic">{"- Required -"}</span>
          )}
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    
    columnHelper.accessor("riskConsequenceComment", {
      header: () => "Risk Consequence Comment",
      cell: (info) => (
        <div className="">
          {info.getValue() || (
            <span className="text-red italic">{"- Required -"}</span>
          )}
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    
    columnHelper.accessor("controlEffectiveness", {
      header: () => "Control Effectiveness",
      cell: (info) => (
        <div className="">
          {info.getValue() || (
            <span className="text-red italic">{"- Required -"}</span>
          )}
        </div>
      ),
      footer: (info) => info.column.id,
    }),
    
    columnHelper.display({
      id: "actions",
      header: () => <span>Actions</span>,
      cell: ({ row }) => (
        <button
          type="button"
          className={`w-auto flex justify-center text-caribbeanCurrent items-center hover:text-black hover:bg-white hover:border-2 hover:border-caribbeanCurrent border border-caribbeanCurrent hover:bg-caribbeanCurrent focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-4 py-2 text-center inline-flex me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-blue-800 ${
      isAssessmentLocked
        ? "bg-gray-400 cursor-not-allowed text-white border-none hover:bg-gray-400"
        : "border-caribbeanCurrent text-black hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    }`}
          disabled={isAssessmentLocked}
          data-drawer-target="drawer-risk-assessment-score"
          data-drawer-show="drawer-risk-assessment-score"
          data-drawer-placement="right"
          aria-controls="drawer-risk-assessment-score"
          onClick={() => handleOpenEditDrawer(row.original.id)}
        >
          <svg
            className="w-4 h-4 text-white-800 dark:text-white me-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
          Assess
        </button>
      ),
    }),
  ];

  const table = useReactTable<Risk>({
    data: paginatedRisks,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting,
    },
    onSortingChange: setSorting,
  });

  return (
    <>
      {/* <!-- Breadcrumb --> */}
      <nav
        className="justify-between  py-3 text-gray-700  sm:flex bg-gray-50"
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0">
          <li>
            <div className="flex items-center">
              <NavLink
                to=""
                className=" text-sm font-medium text-gray-700 hover:text-blue-600  dark:text-gray-400 dark:hover:text-white"
              >
                Risk Assessment
              </NavLink>
            </div>
          </li>

          <li aria-current="page">
            <div className="flex items-center ">
              <svg
                className="rtl:rotate-180 w-3 h-3 mx-1 text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="mx-1 text-sm font-medium text-gray-500 md:mx-2 dark:text-gray-400">
                Assessment
              </span>
            </div>
          </li>
        </ol>
      </nav>
      <h1 className="text-xl mb-3 font-semibold text-gray-700">
        Risk Assessment
      </h1>

      {/* <p className="text-caribbeanCurrent font-semibold">Due date: {dueDate}</p> */}
      <form className="flex max-w-sm my-4 justify-center items-center">
        <label
          htmlFor="countries"
          className="block mb-2 text-md font-medium text-gray-900 dark:text-white"
        >
          Department
        </label>
        <select
          id="countries"
          className="ml-5 bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          onChange={(e) => setSelectedDepartment(e.target.value)}
        >
          <option>All</option>
          {departments &&
            departments.map((department, index) => (
              <option key={index}>{department.name}</option>
            ))}
        </select>
      </form>

      <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4">
        <div className="p-5 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white dark:text-white dark:bg-gray-800 sticky top-0 z-20">
          <div className="w-full flex items-center justify-between">
            <p>Department Risks</p>
            <div className="flex flex-row gap-4 items-center justify-center">
              <div className="">
                <TableSearchBar
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  placeholder="Search risks..."
                />
              </div>
            </div>
          </div>
        </div>
        <div className="rt-wrap relative sm:rounded-lg max-h-[calc(100vh-300px)] overflow-y-auto">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-sm text-jet font-bold bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0 z-10">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    const isSorted = header.column.getIsSorted();
                    const isActionsColumn = header.column.id === "actions";
                    return (
                      <th
                        scope="col"
                        // className={`px-6 py-3 ${
                        //   [
                        //     "likeLihoodValue",
                        //     "likeLihoodComment",
                        //     "riskConsequenceComment",
                        //     "riskConsequenceValue",
                        //     "controlEffectiveness",
                        //     "controlEffectivenessScore",
                        //   ].includes(header.column.id)
                        //     ? "bg-gray-200"
                        //     : ""
                        // }
                        // `}
                        className={`px-6 py-3 ${
                          isActionsColumn
                            ? "sticky right-0 bg-gray-50 dark:bg-gray-700 z-10"
                            : ""
                        }`}
                        key={header.id}
                        aria-sort={
                          isSorted === "asc"
                            ? "ascending"
                            : isSorted === "desc"
                            ? "descending"
                            : "none"
                        }
                      >
                        {header.isPlaceholder ? null : (
                          <button
                            type="button"
                            className={`flex items-center gap-1 select-none ${
                              header.column.getCanSort()
                                ? "cursor-pointer"
                                : "cursor-default"
                            }`}
                            onClick={header.column.getToggleSortingHandler()}
                            title={
                              header.column.getCanSort() ? "Sort" : undefined
                            }
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                            {header.column.getCanSort() && (
                              <span className="text-xs">
                                {isSorted === "asc"
                                  ? "▲"
                                  : isSorted === "desc"
                                  ? "▼"
                                  : "⇅"}
                              </span>
                            )}
                          </button>
                        )}
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            {isLoadingRisks ? (
              <tbody>
                <tr className="text-center">
                  <td colSpan={7} className="text-center">
                    <div className="flex justify-center items-center h-96">
                      <Loader size={"xl"} />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="text-jet font-medium text-xs">
                {table.getRowModel().rows.map((row) => (
                  <>
                    <tr
                      key={row.id}
                      className={`bg-gray hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 ${
                        highlightedRiskId === row.original.id
                          ? "bg-gray-200"
                          : ""
                      }`}
                    >
                      {row.getVisibleCells().map((cell) => {
                        const isActionsColumn = cell.column.id === "actions";
                        return (
                          <td
                            // className={`px-6 py-4 align-top ${
                            //   [
                            //     "likeLihoodValue",
                            //     "likeLihoodComment",
                            //     "riskConsequenceComment",
                            //     "riskConsequenceValue",
                            //     "controlEffectiveness",
                            //     "controlEffectivenessScore",
                            //   ].includes(cell.column.id)
                            //     ? "bg-gray-200"
                            //     : ""
                            // }`}
                            className={`px-6 py-4 align-top ${
                              isActionsColumn
                                ? "sticky right-0 bg-white dark:bg-gray-800"
                                : ""
                            }`}
                            key={cell.id}
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}
                          </td>
                        );
                      })}
                    </tr>
                    <tr className="bg-transparent">
                      {row.getVisibleCells().map((cell) => {
                        const isActionsColumn = cell.column.id === "actions";
                        return (
                          <td
                            className={`px-6 py-2 border-b text-gray-500 text-xs bg-transparent ${
                              isActionsColumn
                                ? "sticky right-0 bg-white dark:bg-gray-800"
                                : ""
                            }`}
                            key={`${cell.id}-score`}
                          >
                            {cell.column.id === "likeLihoodValue" && (
                              <div className="font-bold text-gray-500 whitespace-nowrap">
                                Average Value:{" "}
                                <span
                                >
                                  {row.original.likeLihoodValue ? row.original.likeLihoodValue : 0}
                                </span>
                              </div>
                            )}
                            {cell.column.id === "riskConsequenceValue" && (
                              <div className="font-bold text-gray-500 whitespace-nowrap">
                                Average Value:{" "}
                                <span
                                >
                                  {row.original.riskConsequenceValueScoreAverage ? row.original.riskConsequenceValueScoreAverage : 0}
                                </span>
                              </div>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  </>
                ))}
              </tbody>
            )}
          </table>

          {/* Pagination */}
          <div className="mt-4 pl-10 pr-10 pb-5 text-jet font-medium text-xs ">
            <nav aria-label="Page navigation">
              <ul className="flex justify-between">
                <li className="flex flex-row items-center">
                  <div>
                    <p>Show rows per page</p>
                  </div>
                  <div>
                    <select
                      className="ml-2 bg-gray-50 border border-caribbeanCurrent text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                  </div>
                </li>
                <li className="flex flex-row gap-1 items-center text-gray-500">
                  <div>
                    <p>
                      {currentPage} of {totalPages === 0 ? 1 : totalPages}
                    </p>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      {"<"}
                    </button>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      {">"}
                    </button>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* drawers */}

      {/* score risk */}
      {allRisks.length > 0 && (
        <div
          id="drawer-risk-assessment-score"
          ref={editDrawerRef}
          className={`fixed top-0 right-0 z-50 h-screen p-4 overflow-y-auto transition-transform ${
            isEditDrawerOpen ? "translate-x-0" : "translate-x-full"
          } bg-white w-full md:w-1/4 dark:bg-gray-800`}
          tabIndex={-1}
          aria-labelledby="drawer-risk-assessment-score-label"
        >
          <h5
            id="drawer-label"
            className="inline-flex items-center mb-6 text-base font-semibold text-gray-500  dark:text-gray-400"
          >
            Assessment Risk Scoring
          </h5>
          <p className="text-sm my-4 text-gray-400">
            You are about to review a risk, please keep it professional
          </p>
          <button
            type="button"
            data-drawer-hide="drawer-risk-assessment-score"
            aria-controls="drawer-risk-assessment-score"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
            ref={closeEditRiskDrawerButtonRef}
            onClick={() => setIsEditDrawerOpen(false)}
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
          <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600  mb-4 p-4">
            <div className="mb-6">
              <label
                htmlFor="perspective"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Perspective
              </label>
              <input
                type="text"
                id="perspective"
                value={
                  currentRiskDetails && currentRiskDetails.perspective
                    ? currentRiskDetails.perspective
                    : ""
                }
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Perspective goes here"
                required
                disabled
                readOnly
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskGoals"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Objective
              </label>
              <input
                type="text"
                id="objective"
                value={
                  currentRiskDetails && currentRiskDetails.objective
                    ? currentRiskDetails.objective
                    : ""
                }
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Objective goes here"
                required
                disabled
                readOnly
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskName"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Name
              </label>
              <input
                type="text"
                id="riskName"
                value={
                  currentRiskDetails && currentRiskDetails.riskName
                    ? currentRiskDetails.riskName
                    : ""
                }
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk title goes here"
                required
                disabled
                readOnly
              />
            </div>
            {moreDetailsRequested && (
              <>
                <div className="mb-6">
                  <label
                    htmlFor="source"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Source
                  </label>
                  <input
                    type="text"
                    id="source"
                    value={
                      currentRiskDetails && currentRiskDetails.source
                        ? currentRiskDetails.source
                        : ""
                    }
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Source goes here"
                    required
                    disabled
                    readOnly
                  />
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="description"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Description
                  </label>
                  <textarea
                    readOnly
                    id="description"
                    disabled
                    value={
                      currentRiskDetails && currentRiskDetails.description
                        ? currentRiskDetails.description
                        : ""
                    }
                    rows={4}
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder=""
                  ></textarea>
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="rootCauses"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Root Causes
                  </label>
                  <textarea
                    id="rootCauses"
                    readOnly
                    disabled
                    rows={4}
                    value={
                      currentRiskDetails && currentRiskDetails.rootCause
                        ? currentRiskDetails.rootCause
                        : ""
                    }
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder=""
                  ></textarea>
                </div>
              </>
            )}
            <div className="flex justify-center">
              <button
                onClick={handleMoreDetailsRequest}
                className="text-center font-bold text-caribbeanCurrent flex items-center"
              >
                {moreDetailsRequested ? (
                  <>
                    Collapse{" "}
                    <span>
                      <IoIosArrowDown />
                    </span>
                  </>
                ) : (
                  <>
                    See More Details{" "}
                    <span>
                      <IoIosArrowDown />
                    </span>
                  </>
                )}
              </button>
            </div>
          </div>
          <form
            key={drawerKey}
            onSubmit={handleCreateRiskAssessment}
            className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600  mb-4 p-4"
          >
            <div className="mb-6">
              <label
                htmlFor="likeLihoodValue"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Likelihood Score
              </label>
              <select
                id="likeLihoodValue"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                defaultValue={
                  currentRiskDetails && currentRiskDetails.likeLihoodValue
                    ? currentRiskDetails.likeLihoodValue
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    likeLihoodValue: e.target.value,
                  }));
                }}
                value={
                  currentRiskDetails && currentRiskDetails.likeLihoodValue
                    ? currentRiskDetails.likeLihoodValue
                    : ""
                }
              >
                <option>0 Rating</option>
                {getLikelihoodValues(config).map(([score, name]) => (
                  <option value={score} key={score}>
                    {score} {name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-6">
              <label
                htmlFor="likeLihoodComment"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Likelihood Comment
              </label>
              <textarea
                id="likeLihoodComment"
                rows={4}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk likelihood comment here..."
                defaultValue={
                  currentRiskDetails && currentRiskDetails.likeLihoodComment
                    ? currentRiskDetails.likeLihoodComment
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    likeLihoodComment: e.target.value,
                  }));
                }}
              ></textarea>
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskConsequenceValue"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Consequence Value
              </label>
              <select
                id="riskConsequenceValue"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                defaultValue={
                  currentRiskDetails && currentRiskDetails.riskConsequenceValue
                    ? currentRiskDetails.riskConsequenceValue
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    riskConsequenceValue: e.target.value,
                  }));
                }}
                value={
                  currentRiskDetails && currentRiskDetails.riskConsequenceValue
                    ? currentRiskDetails.riskConsequenceValue
                    : ""
                }
              >
                <option>0 Rating</option>
                {getConsequenceValues(config).map(([score, name]) => (
                  <option value={score} key={score}>
                    {score} {name}
                  </option>
                ))}
              </select>
            </div>
          
            <div className="mb-6">
              <label
                htmlFor="riskConsequenceComment"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Consequence Comment
              </label>
              <textarea
                id="riskConsequenceComment"
                rows={4}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk consequence comment here..."
                defaultValue={
                  currentRiskDetails &&
                  currentRiskDetails.riskConsequenceComment
                    ? currentRiskDetails.riskConsequenceComment
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    riskConsequenceComment: e.target.value,
                  }));
                }}
              ></textarea>
            </div>

            <div className="mb-6">
              <label
                htmlFor="riskConsequenceValue"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Control Strength
              </label>
              <select
                id="controlStrength"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                defaultValue={
                  currentRiskDetails &&
                  currentRiskDetails.controlEffectivenessScore
                    ? currentRiskDetails.controlEffectivessScore
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    controlEffectivenessScore: e.target.value,
                  }));
                }}
                value={
                  currentRiskDetails &&
                  currentRiskDetails.controlEffectivenessScore
                    ? currentRiskDetails.controlEffectivenessScore
                    : ""
                }
              >
                <option>0 Rating</option>
                {getControlEffectivenessValues(config).map(([score, name]) => (
                  <option value={score} key={score}>
                    {score} {name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-6">
              <label
                htmlFor="controlEffectiveness"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Control Effectiveness
              </label>
              <textarea
                id="controlEffectiveness"
                rows={4}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Control effectiveness here..."
                defaultValue={
                  currentRiskDetails && currentRiskDetails.controlEffectiveness
                    ? currentRiskDetails.controlEffectiveness
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    controlEffectiveness: e.target.value,
                  }));
                }}
              ></textarea>
            </div>

            {/* <div className="mb-6">
              <label
                htmlFor="responseText"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Response
              </label>
              <textarea
                id="responseText"
                rows={4}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk response here..."
                defaultValue={
                  currentRiskDetails && currentRiskDetails.responseText
                    ? currentRiskDetails.responseText
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    responseText: e.target.value,
                  }));
                }}
              ></textarea>
            </div> */}

            <div className="flex gap-4">
              {(() => {
                const allScoresProvided =
                  Number(currentRiskDetails?.likeLihoodValue) > 0 &&
                  Number(currentRiskDetails?.riskConsequenceValue) > 0 &&
                  Number(currentRiskDetails?.controlEffectivenessScore) > 0;
                return (
                  <button
                    disabled={isSubmitting || !allScoresProvided}
                    type="submit"
                    title={
                      !allScoresProvided
                        ? "Likelihood, Impact, and Control Strength scores are all required"
                        : undefined
                    }
                    className={`justify-center items-center inline-flex text-white w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 focus:outline-none block ${
                      isSubmitting || !allScoresProvided
                        ? "bg-gray-400 cursor-not-allowed opacity-60"
                        : "bg-caribbeanCurrent hover:bg-blue-800 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent dark:focus:ring-caribbeanCurrent"
                    }`}
                    data-drawer-placement="right"
                  >
                    {isSubmitting ? <Loader size="sm" /> : "Submit"}
                  </button>
                );
              })()}

            <button
              onClick={(e) => {
                e.preventDefault()
                setIsEditDrawerOpen(false)
              }}
              className="justify-center items-center border-2 border-caribbeanCurrent inline-flex text-black hover:text-black hover:caribbeanCurrent w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block"     
              data-drawer-placement="right"
            >
              Cancel
            </button>
            </div>

            <div className="flex justify-end items-right mt-4">
              <button
                type="button"
                disabled={isDeleting}
                className="text-white w-full border-2 bg-riskRed border-riskRed hover:bg-white hover:text-black focus:ring-4 focus:outline-none focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-caribbeanCurrent dark:text-caribbeanCurrent dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-caribbeanCurrent"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenModal(true);
                }}
              >
                {isDeleting ? <Loader size="sm" /> : "Delete Risk"}
              </button>
            </div>

            <Modal
              show={openModal}
              size="md"
              onClose={() => setOpenModal(false)}
              popup
            >
              <Modal.Header />
              <Modal.Body>
                <div className="text-center">
                  <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                  <div className="gap-0 mb-4">
                    <h3 className="text-lg font-normal text-gray-500 dark:text-gray-400">
                      Are you sure you want to delete this risk?
                    </h3>
                    <h4 className="text-gray-500 dark:text-gray-400">
                      <span className="font-bold text-black">Note:</span> You
                      can't undo this action
                    </h4>
                  </div>
                  <div className="flex justify-center gap-4">
                    <Button
                      className="bg-caribbeanCurrent"
                      onClick={deleteRisk}
                    >
                      {isDeleting ? <Loader size="sm" /> : "Delete Risk"}
                    </Button>
                    <Button color="gray" onClick={() => setOpenModal(false)}>
                      Cancel
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>

            {/* Collapsible vote summaries */}
            <div className="space-y-3">
              

              

              
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default connect()(AdminRiskAssessmentFinalization);